import FlowConfigBase from '#client/config/FlowConfigBase';
import AUTH_POLICY from '#client/constants/authPolicy';
import * as ROUTES from '#client/constants/routes';

import PAGES, { PAGE_KEYS } from '../flowPageConfig';

export default FlowConfigBase.createEntry({
  id: 'llc-addons',
  pageKeys: [
    PAGE_KEYS.CONFIRMATION,
    PAGE_KEYS.BUSINESS_LICENSE_REPORT,
    PAGE_KEYS.BANKING,
    PAGE_KEYS.DOMAIN_NAME_REGISTRATION,
    PAGE_KEYS.WEBSITE_BUILDER,
    PAGE_KEYS.CHECKOUT,
    PAGE_KEYS.CONCLUSION
  ],
  pageConfigs: {
    [PAGES.CHECKOUT.pageComponent]: {
      pageComponentProps: {
        slotProps: {
          businessCardProps: {
            businessInfoFields: {
              businessName: {
                disabled: true
              }
            }
          },
          listCallout: {
            showFilingGuarantee: false
          },
          pageHeader: {
            showSubtitle: false
          }
        }
      }
    }
  },
  authPolicy: AUTH_POLICY.REQUIRED,
  autoLoadBusiness: true,
  autoResume: false,
  entityType: 'llc',
  postOrderRedirect: ROUTES.UJM_COMPLETE_FORMATION,
  priceListUuids: {
    development: '3c9da872-c96d-4e28-be04-4dd8cf8e1a2e',
    production: '19a705a4-3241-4f65-aef1-74a95f6f49b8'
  },
  requiredEntitlements: ['formation_llc'],
  featureFlags: undefined
});
